/**
 * Requests a url via GET, executing a given callback function with the response and error if any.
 *
 * @param {String} url The url to request.
 * @param {String} method The http method to use.
 * @param {Object} params An optional params object containing additional headers and the body for the XHR.
 * @param {Function} callback The function to call when the request is done.
 */
function request(url, method, params, callback) {
  const start = now()
  var xhr = new XMLHttpRequest()
  xhr.onload = function() {
    xhr.duration = getDuration(start, now())
    if (xhr.status >= 200 && xhr.status < 300) {
      callback(null, xhr)
    } else {
      callback(new Error(xhr.status + ' ' + xhr.statusText), xhr)
    }
  }

  xhr.onerror = function(error) {
    error.duration = getDuration(start, now())
    callback(error)
  }

  xhr.open(method, url, true)
  if (params && params.headers) {
    var keys = Object.keys(params.headers)
    var length = keys.length
    for (var i = 0; i < length; i++) {
      var key = keys[i]
      xhr.setRequestHeader(key, params.headers[key])
    }
  }
  xhr.send(params && params.body)
}

export default request

function now() {
  if (typeof performance !== 'undefined') {
    return performance.now()
  }

  return Date.now()
}

function getDuration(start, end) {
  if (typeof start !== 'number' || typeof end !== 'number') {
    return undefined
  }
  return Math.ceil(end - start)
}
